"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonProperties = exports["default"] = void 0;

var _baseColors = _interopRequireDefault(require("../baseColors"));

var _spacing = _interopRequireDefault(require("../../tokens/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var button = {
  "default": {
    background: _baseColors["default"].dodgerBlue,
    backgroundHover: _baseColors["default"].vividCerulean,
    backgroundFocus: _baseColors["default"].vividCerulean,
    backgroundActive: _baseColors["default"].frenchBlue,
    text: _baseColors["default"].smokySnow,
    icon: 'smokySnow',
    border: _baseColors["default"].frenchBlue,
    borderHover: _baseColors["default"].frenchBlue,
    borderFocus: _baseColors["default"].frenchBlue,
    borderActive: _baseColors["default"].frenchBlue
  },
  primary: {
    background: _baseColors["default"].tekionGreen,
    backgroundHover: _baseColors["default"].amzonite,
    backgroundFocus: _baseColors["default"].amzonite,
    backgroundActive: _baseColors["default"].persianGreen,
    text: _baseColors["default"].smokySnow,
    icon: 'smokySnow',
    border: _baseColors["default"].persianGreen,
    borderHover: _baseColors["default"].persianGreen,
    borderFocus: _baseColors["default"].persianGreen,
    borderActive: _baseColors["default"].persianGreen
  },
  secondary: {
    background: _baseColors["default"].white,
    backgroundHover: 'rgba(0,0,0,0.05)',
    backgroundFocus: 'rgba(0,0,0,0.05)',
    backgroundActive: '#DADADA',
    text: _baseColors["default"]["default"],
    icon: 'blackOlive',
    border: _baseColors["default"].atomic,
    borderHover: _baseColors["default"].black,
    borderFocus: _baseColors["default"].black,
    borderActive: _baseColors["default"].black
  },
  link: {
    text: _baseColors["default"].dodgerBlue,
    textActive: _baseColors["default"].dodgerBlue,
    icon: 'dodgerBlue',
    hover: _baseColors["default"].dodgerBlue,
    focus: _baseColors["default"].dodgerBlue,
    background: 'tranparent'
  },
  disabled: {
    icon: 'white',
    background: _baseColors["default"].silverSand,
    border: _baseColors["default"].lighterGrey,
    secondary: {
      icon: 'lighterGrey',
      background: _baseColors["default"].white,
      border: _baseColors["default"].lighterGrey
    },
    link: {
      icon: 'lighterGrey',
      background: _baseColors["default"].white,
      border: _baseColors["default"].white
    }
  }
};
var buttonProperties = {
  radius: '3px',
  height: '38px',
  minWidth: '90px',
  maxWidth: '280px',
  padding: _spacing["default"].small
};
exports.buttonProperties = buttonProperties;
var _default = button;
exports["default"] = _default;